import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import SectionHeading from '../home/SectionHeading';
import '../home/home.css';

type Channel = {
  label: string;
  value: string;
  href: string;
};

const channels: Channel[] = [
  { label: 'Email', value: 'saadhzubairi@outlook.com', href: 'mailto:saadhzubairi@outlook.com' },
  { label: 'LinkedIn', value: 'in/saadhzubairi', href: 'https://www.linkedin.com/in/saadhzubairi/' },
  { label: 'GitHub', value: '@saadhzubairi', href: 'https://github.com/saadhzubairi/' },
  { label: 'Calendly', value: 'Book a 30-minute call', href: 'https://calendly.com/saadhzubairi/30min' },
  { label: 'Zoom', value: 'Personal meeting room', href: 'https://nyu.zoom.us/my/saadhzubairi' },
  { label: 'Discord', value: 'saadhzubairi#1469', href: 'https://discord.com/users/saadhzubairi#1469' },
];

const ease = [0.23, 1, 0.32, 1] as const;

const Connect = () => {
  return (
    <section id="Contact" className="home-section home-contact-section">
      <div className="home-section-inner">
        <SectionHeading title="Contact" />

        <div className="home-section-body">
          <motion.p
            className="home-about-paragraph"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.6, ease }}
          >
            Based in New York and open to new roles. Happy to talk through full-time
            work, consulting, or infrastructure and AI ideas worth building.
          </motion.p>

          <div className="home-contact-grid">
            {channels.map((c, i) => (
              <motion.a
                key={c.label}
                href={c.href}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true, margin: '-40px' }}
                transition={{ duration: 0.45, ease, delay: 0.04 * i }}
                className="home-contact-card"
              >
                <h3>{c.label}</h3>
                <p>{c.value}</p>
                <ArrowUpRight className="home-contact-card-icon" aria-hidden />
              </motion.a>
            ))}
          </div>
        </div>

        <footer className="home-colophon">
          <span>Designed and built by Saad Zubairi</span>
          <a href="#Home">Back to top</a>
        </footer>
      </div>
    </section>
  );
};

export default Connect;
